import React, { Component } from "react"
import Cell from "./Cell"
import "./Board.css"

class Board extends Component {
  static defaultProps = {
    nrows: 3,
    ncols: 3,
    chanceLightStartsOn: 0.4,
  };
  constructor(props) {
    super(props)
    this.state = {
      hasWon: false,
      board: this.createBoard(),
    }
  }

  createBoard() {
    let board = []
    let hasWon = board.every(row => row.every(cell => !cell))
    while (hasWon) {
      board = []
      for (let y = 0; y < this.props.nrows; y++) {
        let row = []
        for (let x = 0; x < this.props.ncols; x++) {
          row.push(Math.random() < this.props.chanceLightStartsOn)
        }
        board.push(row)
      }
      hasWon = board.every(row => row.every(cell => !cell))
    }
    this.setState({ board, hasWon })
    return board
  }

  flipCellsAround(coord) {
    let { ncols, nrows } = this.props
    let board = this.state.board
    let [y, x] = coord.split("-").map(Number)

    function flipCell(y, x) {
      if (x >= 0 && x < ncols && y >= 0 && y < nrows) {
        board[y][x] = !board[y][x]
      }
    }

    flipCell(y, x)
    flipCell(y - 1, x)
    flipCell(y + 1, x)
    flipCell(y, x - 1)
    flipCell(y, x + 1)

    let hasWon = board.every(row => row.every(cell => !cell))

    this.setState({ board, hasWon })
  }

  render() {
    let tableBoard = []
    for (let y = 0; y < this.props.nrows; y++) {
      let row = []
      for (let x = 0; x < this.props.ncols; x++) {
        let coord = `${y}-${x}`
        row.push(
          <Cell
            key={coord}
            isLit={this.state.board[y][x]}
            flipCellsAroundMe={() => this.flipCellsAround(coord)}
          />
        )
      }
      tableBoard.push(<tr key={y}>{row}</tr>)
    }

    return (
      <div>
        {this.state.hasWon ? (
          <div className="winner" onClick={() => this.createBoard(this)}>
            <span className="neon-orange">YOU</span>
            <span className="neon-blue">WIN!</span>
          </div>
        ) : (
          <div>
            <table className="Board">
              <tbody>{tableBoard}</tbody>
            </table>
          </div>
        )}
      </div>
    )
  }
}

export default Board
